export class JSConn {
  constructor () {
    this.apiParams = {}
    this.apiCallStatus = 'success'
    this.formParams = {}
    this.fromRoutePath = ''
    this.toRoutePath = ''
    this.response = {}
    this.error = {}
    this.dataForStore = {}
    this.halted = false
    this.toastMessage = ''
  }
}
